import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getQualityAttribute,
  addQualityAttribute,
  updateQualityAttribute,
} from "../../../common/services/products/qualityAttributeService";
import { getProducts } from "../../../common/services/products/productService";
import { getOrganizations } from "../../../common/services/auth/organizationService";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import QualityAttributeHistory from "./qualityAttributeHistory";
import { withTranslation } from "react-i18next";

class QualityAttribute extends Form {
  state = {
    data: {
      qualityAttributeId: "",
      name: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    qualityAttributeId: Joi.string(),
    name: Joi.string().required().label(this.props.t("Name")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    //try{
    const { qualityAttributeId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var qualityAttribute = {};

    if (!isNew) {
      qualityAttribute = await getQualityAttribute(qualityAttributeId);
      qualityAttribute.eventId = uuid();
    } //New User Add
    else {
      qualityAttribute = {
        qualityAttributeId: qualityAttributeId,
        name: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({
      data: this.mapToViewModel(qualityAttribute),
      isLoading: false,
    });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(qualityAttribute.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(qualityAttribute.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });

    this.setState({ products: await getProducts() });
    this.setState({ organizations: await getOrganizations() });

    // }
    // catch(ex)
    // {
    //     //Handle Erorr..
    // }
  }

  mapToViewModel(qualityAttribute) {
    return {
      qualityAttributeId: qualityAttribute.qualityAttributeId,
      name: qualityAttribute.name,
      active: qualityAttribute.active,
      eventId: qualityAttribute.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      //Reset the event ID
      const data = { ...this.state.data };
      data.eventId = uuid();
      this.setState({ data: data });

      if (!isNew) {
        await updateQualityAttribute(this.state.data);
        toast.success(t("QualityAttributeUpdated"));
      } else {
        await addQualityAttribute(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.qualityAttributeId, this.state.data.name);
        toast.success(t("QualityAttributeAdded"));
      }

      //Call back to the select list to allow it to update.
      this.props.submitCallbackFunction(this.state.data);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate } = this.state;

    if (isLoading) return <Loading />;

    const { t, qualityAttributeId, allowEdit } = this.props;

    return (
      <div className="container-fluid">
        <form className="form-inline" onSubmit={this.handleSubmit}>
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {this.renderInput("name", t("QualityAttributeName"))}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={1}
              id="useraccount-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              <Tab eventKey={1} title={t("History")}>
                <QualityAttributeHistory
                  qualityAttributeId={qualityAttributeId}
                />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["products"])(QualityAttribute);
